import { Link } from "react-router-dom";
import { Monitor, Globe, Mail, MapPin, Phone } from "lucide-react";

const allCities = [
  { slug: "beziers", name: "Béziers" },
  { slug: "narbonne", name: "Narbonne" },
  { slug: "agde", name: "Agde" },
  { slug: "sete", name: "Sète" },
  { slug: "montpellier", name: "Montpellier" },
  { slug: "pezenas", name: "Pézenas" },
  { slug: "vendres", name: "Vendres" },
  { slug: "serignan", name: "Sérignan" },
  { slug: "valras", name: "Valras-Plage" },
  { slug: "capestang", name: "Capestang" },
  { slug: "lezignan", name: "Lézignan-Corbières" },
  { slug: "clermont", name: "Clermont-l'Hérault" },
  { slug: "marseillan", name: "Marseillan" },
  { slug: "servian", name: "Servian" },
  { slug: "frontignan", name: "Frontignan" },
  { slug: "lodeve", name: "Lodève" },
  { slug: "lunel", name: "Lunel" },
  { slug: "vias", name: "Vias" },
  { slug: "portiragnes", name: "Portiragnes" },
  { slug: "florensac", name: "Florensac" },
  { slug: "bedarieux", name: "Bédarieux" },
  { slug: "meze", name: "Mèze" },
  { slug: "balaruc", name: "Balaruc-les-Bains" },
  { slug: "magalas", name: "Magalas" },
  { slug: "colombiers", name: "Colombiers" },
  { slug: "sauvian", name: "Sauvian" },
  { slug: "villeneuve", name: "Villeneuve-lès-Béziers" },
  { slug: "nissan", name: "Nissan-lez-Enserune" },
  { slug: "coursan", name: "Coursan" },
];

const Footer = () => {
  return (
    <footer className="border-t border-border/30 bg-card/40">
      <div className="container mx-auto px-4 py-10 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="space-y-4 col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0">
                <span className="text-primary font-mono font-bold text-sm">SW</span>
              </div>
              <span className="font-bold text-base md:text-lg text-foreground">
                SUDWEB<span className="text-primary">-TECH</span>
              </span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Expert en dépannage informatique, assemblage PC sur mesure et création de sites web professionnels à Béziers et dans un rayon de 50km.
            </p>
            <p className="text-xs text-primary font-semibold flex items-center gap-1.5">
              <span className="h-2 w-2 rounded-full bg-success animate-pulse" />
              Disponible 24h/24 · 7j/7 · Jours fériés
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/pc-sur-mesure" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2">
                  <Monitor size={14} /> PC Sur Mesure
                </Link>
              </li>
              <li>
                <Link to="/creation-web" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2">
                  <Globe size={14} /> Création Web
                </Link>
              </li>
              {[["/depannage-informatique","Dépannage informatique"],["/conseil-informatique","Conseil informatique"],["/assistance-bureautique","Assistance bureautique"],["/pannes","Pannes courantes"],["/tarifs","Tarifs"]].map(([to,l]) => (
                <li key={to}><Link to={to} className="text-sm text-muted-foreground hover:text-primary transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Entreprise</h3>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="text-sm text-muted-foreground hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link to="/blog" className="text-sm text-muted-foreground hover:text-primary transition-colors">Blog</Link></li>
              <li><Link to="/rdv" className="text-sm text-muted-foreground hover:text-primary transition-colors">Rendez-vous</Link></li>
              {[["/realisations","Réalisations"],["/avis","Avis clients"],["/a-propos","À propos"],["/mentions-legales","Mentions légales"],["/confidentialite","Confidentialité"]].map(([to,l]) => (
                <li key={to}><Link to={to} className="text-sm text-muted-foreground hover:text-primary transition-colors">{l}</Link></li>
              ))}
              <li><Link to="/plan-du-site" className="text-sm text-muted-foreground hover:text-primary transition-colors">Plan du site</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:sudwebtech.contact@gmail.com" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2">
                  <Mail size={14} className="text-primary" /> sudwebtech.contact@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+33669260492" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2">
                  <Phone size={14} className="text-primary" /> 06 69 26 04 92
                </a>
              </li>
              <li className="text-sm text-muted-foreground flex items-center gap-2">
                <MapPin size={14} className="text-primary" /> Vendres (34350) – Béziers
              </li>
            </ul>
          </div>
        </div>

        {/* Zones d'intervention SEO - expanded */}
        <div className="border-t border-border/30 mt-8 pt-6">
          <h3 className="font-semibold text-foreground mb-3 text-xs uppercase tracking-wider text-center">Communes desservies</h3>
          <div className="flex flex-wrap justify-center gap-x-3 gap-y-1">
            {allCities.map(city => (
              <span key={city.slug}
                className="text-xs text-muted-foreground hover:text-primary transition-colors"
              >{city.name}</span>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link to="/zones-intervention" className="text-xs text-primary hover:text-primary-glow font-semibold underline underline-offset-4">
              Voir toutes nos zones d'intervention (Hérault & Aude) →
            </Link>
          </div>
        </div>

        <div className="border-t border-border/30 mt-8 md:mt-12 pt-6 md:pt-8 text-center">
          <p className="text-xs md:text-sm text-muted-foreground">
            © {new Date().getFullYear()} SUDWEB-TECH. Tous droits réservés. | Dépannage informatique Béziers | Création de sites web | PC sur mesure
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
